import React from 'react'
import { catchMessage, elseMessage, successMessage } from '../../comman/Message'
import { changeResourceStatusApi } from '../../services/resource'
import ModalBox from '../../components/modal/ModalBox'

const ChangeStatusResource = ({ show, close, status, id, listing, name }) => {

    //--------------change-status-meetups-------------------------
    const changeStatus = async () => {
        try {
            let data = ({ status: !status, id: id })
            const res = await changeResourceStatusApi(data)
            if (res.data.status === 200) {
                close()
                listing()
                successMessage(res)
            } else {
                elseMessage(res)
            }
        } catch (e) {
            catchMessage(e)
        }
    }
    return (
        <ModalBox
            status={show}
            onClose={close}
            title={`${status ? "Block" : "Unblock"} Resource`}
            description={
                < span >
                    Do you want to {!status ? "Unblock" : "block"} <strong>{name}</strong> ?
                </span >
            }
            action={changeStatus}
        />
    )
}

export default ChangeStatusResource